import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const PermitCompletedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.PERMIT_COMPLETED),
  estimatedPermitApprovalDate: z.coerce.date(),
});
